import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const MetaContext = createContext(null);

export function MetaProvider({ children }) {
  const { user } = useAuth();
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (user && user.id) {
      api.get("/meta").then((r) => setMeta(r.data)).catch((e) => console.warn("Meta load failed", e));
    }
  }, [user]);

  const stageByKey = useCallback(
    (key) => (meta?.stages || []).find((s) => s.key === key),
    [meta],
  );
  const responseLabel = useCallback(
    (v) => (meta?.response_statuses || []).find((r) => r.value === v)?.label || v,
    [meta],
  );

  const value = useMemo(
    () => ({ meta, stageByKey, responseLabel }),
    [meta, stageByKey, responseLabel],
  );

  return <MetaContext.Provider value={value}>{children}</MetaContext.Provider>;
}

export const useMeta = () => useContext(MetaContext);
